// extracted by mini-css-extract-plugin
export var chip = "_pt-0";
export var icon = "_pt-1";
export var remove = "_pt-2";
export var removeIcon = "_pt-3";